export enum MediaType {
   VOICE = 'Voice',
   DIGITAL ='Digital',
   EMAIL = 'Email',
   VOICEMAIL = 'Voicemail',
   VIDEOCALL= 'VideoCall'
}

export enum MediaTypeId {
   Email = 1,
   ChatItem = 3,
   PhoneCall = 4,
   VoiceEmail = 5,
   WorkItem = 6,
   Digital = 9
}